import request from '@/config/axios'

export interface LiveTagVO {
  id?: number
  name: string
  recommended?: boolean
  sort?: number
  status?: number
}

export const page = (params: any) => request.get({ url: '/live/tag/page', params })
export const save = (data: LiveTagVO) => request.post({ url: '/live/tag/save', data })
export const deleteTag = (id: number) =>
  request.delete({ url: '/live/tag/delete', params: { id } })
